/**
 * Adapptio: Set of base components
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppClient, ITranslationManager } from "@adapptio/lib-core";
import { registerComponents } from ".";
import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericViewComponentDefinition } from "@adapptio/lib-components";

export const registerExtension = (application: IAppClient): void => {
	const registry = application.get("componentRegistry");
	const translationManager = application.get("translationManager");

	registerComponents(registry, translationManager);

	// Register server/client implementation specific components
	//registry.register(ComponentChart);
};

// We must export for sandbox specifically because some dependencies must be bundled only client-side
export const registerStandalone = (
	registry: ItemRegistry<TGenericViewComponentDefinition>,
	translationManager: ITranslationManager
): void => {
	registerComponents(registry, translationManager);

	// Register server/client implementation specific components
	//registry.register(ComponentChart);
};
